// removed by extract-text-webpack-plugin
module.exports = {"container":"_3al6KfjODgHhsL7h0BzZD","iphone":"_22_WLtn82kweLClV-dKhdg","content":"_1pwR0fWkp07BEve-AfZWqm"};


//////////////////
// WEBPACK FOOTER
// ../components/iphone/styles.module.css
// module id = 475
// module chunks = 0